export default "__VITE_ASSET__C27$LlIx__"